import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { IconModule, GenericLinkModule } from '@spartacus/storefront';
import { KbNotificationsComponent } from './kb-notifications.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';



@NgModule({
  declarations: [KbNotificationsComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    IconModule,
    GenericLinkModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        NotificationComponent: {
          component: KbNotificationsComponent,
          guards: [SecureGuard],
        },
      },
    } as CmsConfig),
  ],
  exports:[KbNotificationsComponent]
})
export class KbNotificationsModule { }
